const colors = {
  Aluminium: '#808284',

  BrightGreen: '#32D74B',
  LightBlue: '#F2FAFA',
  DarkBlue: '#25355F',
  DarkBlueishGreenish: '#2F4F59',
  Transparent: '#00000000',

  LightGrey200: '#D9D9D9',
  LightGrey400: '#8D8D8D',

  LightGreen: '#3ABF37',
  LightGreen20: '#3ABF3733',
  SecondaryLightGreen: '#EAF5EA',
  SecondaryLightGreenStoke: '#C1E4C1',

  /* New colors 2024 */
  Teal400: '#0396A8',
  White: '#FFFFFF',

  Black: '#333333',
  MidnightTeal400: '#395966',
  MidnightTeal300: '#617A85',
  Watermelon400: '#EC7161',

  /* Secondary Peaches */
  Peach400: '#FFA37A',
  Peach200: '#FFD1BC',
  Peach100: '#FFE8DD',
  Peach50: '#FFF9F6',

  /* Blues */
  Teal500: '#007F8F',
  MutedTeal400: '#81BBC2',
  MutedTeal300: '#B3D6DA',
  MutedTeal200: '#D1E6E9',
  MutedTeal100: '#E1EFEF',
  MutedTeal50: '#F1F7F7',
  OceanTeal400: '#A0CBCB',

  /* Greys */
  Grey: '#EEEEEE',
  Grey400: '#49494A',
  Grey350: '#818181',
  Grey300: '#A4A4A4',
  Grey250: '#BABAC2',
  Grey200: '#D1D1D1',
  Grey100: '#E8E8E8',
  Grey50: '#F4F4F4',
  Grey25: '#F9F9F9',
  MetalGrey: '#F7F9FA',
  MetalGrey50: '#F8F7FB',
  MetalGrey75: '#EEEDF1',

  /* Golden Yellows */
  GoldenYellow400: '#FCBE1F',
  GoldenYellow300: '#FFD25E',
  GoldenYellow200: '#FFDD9C',
  GoldenYellow100: '#FFEBC4',
  GoldenYellow50: '#FFF9EE',

  /* Scale Colors */
  Salomie: '#FFE38A',
  Deco: '#D8DA87',
  PineGlade: '#B0D184',
  DeYork: '#87C882',
  Fern: '#5DBF7F',

  /* System Message colors */
  SuccessGreen: '#2E992C',
  ErrorRed: '#D94A38',
  WarnOrange: '#F8931D',
  WarnYellow: '#F6C61C',

  SecondaryLightRed: '#FBEDEB',
  SecondaryUserText: '#617A85',

  /* Purples */
  Purple400: '#B89BEF',
  Purple300: '#DBCDF7',
  Purple200: '#EDE6FB',
  Purple100: '#F8F5FD',

  /* Greens */
  Green400: '#2E992C',
  Green300: '#97CC95',
  Green200: '#C1E4C1',
  Green100: '#EAF5EA',
  Green50: '#F9FCF9',

  /* Medals */
  Gold: '#FFD700',
  Silver: '#C0C0C0',
  Bronze: '#CD7F32'
}
export default colors
